import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Home } from "lucide-react";
import { fmtDate, daysUntil, tripTitle } from "../../lib/trips";

export const surveyStatus = (t) => {
  if (!t.post_reminder_enabled) return { label: "Encuesta desactivada", cls: "bg-slate-100 text-slate-600" };
  if (t.post_reminder_sent_at) return { label: "Encuesta enviada", cls: "bg-emerald-50 text-emerald-700" };
  return { label: "Encuesta pendiente", cls: "bg-amber-50 text-amber-700" };
};

const dayLabel = (n) => (n === 0 ? "Hoy" : n === 1 ? "Mañana" : `En ${n} días`);

export const ReturnsThisWeekCard = ({ trips, onOpen }) => {
  const returns = trips
    .filter((t) => t.return_date && daysUntil(t.return_date) >= 0 && daysUntil(t.return_date) <= 7)
    .sort((a, b) => new Date(a.return_date) - new Date(b.return_date));

  return (
    <Card className="glass-card border-0 mt-5" data-testid="returns-week-card">
      <CardHeader>
        <CardTitle className="text-lg font-heading text-sky-900 flex items-center gap-2">
          <Home className="w-5 h-5" />
          Regresos esta semana
        </CardTitle>
        <CardDescription>Viajes que vuelven en los próximos 7 días</CardDescription>
      </CardHeader>
      <CardContent>
        {returns.length === 0 ? (
          <p className="text-sm text-sky-700/60 py-4 text-center" data-testid="returns-week-empty">
            No hay regresos en los próximos 7 días.
          </p>
        ) : (
          <div className="space-y-2">
            {returns.map((t) => {
              const st = surveyStatus(t);
              const n = daysUntil(t.return_date);
              return (
                <button
                  key={t.id}
                  type="button"
                  onClick={() => onOpen(t.client, t)}
                  className="w-full flex items-center justify-between gap-3 px-3 py-2 rounded-lg bg-white/70 border border-sky-100 hover:border-sky-300 hover:bg-sky-50/60 transition-colors text-left"
                  data-testid={`return-row-${t.id}`}
                >
                  <div className="min-w-0">
                    <p className="font-semibold text-sky-900 text-sm truncate">
                      {t.client.name} {t.client.last_name || ""}
                    </p>
                    <p className="text-xs text-sky-700/70 truncate">
                      {tripTitle(t)} · regresa {fmtDate(t.return_date)}
                    </p>
                  </div>
                  <div className="flex flex-col items-end gap-1 shrink-0">
                    <span className="text-xs font-semibold text-sky-800">{dayLabel(n)}</span>
                    <span className={`text-[10px] px-2 py-0.5 rounded-full ${st.cls}`} data-testid={`return-survey-status-${t.id}`}>
                      {st.label}
                    </span>
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
